import React from 'react'
import AccordionContainer from '../../../components/ui/AccordionContainer'
import { Box, Skeleton, VStack } from '@chakra-ui/react'
import { ReportListItem } from './ReportListItem'

import { IProduct, IProductReport } from '../../../store/ProductStore'

export interface ReportListContainerProps {
  products?: IProduct[]
  onItemClick: (report: IProductReport) => void
  isAdmin: boolean
}

// TODO: remove this
const ReportListContainer = ({
  products,
  onItemClick,
  isAdmin,
}: ReportListContainerProps) => {
  const productsWithReports = products?.filter(product => product.reports.length > 0)
  return (
    <>
      {productsWithReports?.map(product => (
        <ReportListWrapper
          key={product.id}
          product={product}>
          {product.reports.map(report => {
            return (
              <ReportListItem
                key={report.id}
                report={report}
                onClick={() => onItemClick(report)}
                isAdmin={isAdmin}
              />
            )
          })}
        </ReportListWrapper>
      ))}
    </>
  )
}

export interface ProductListProps {
  product: IProduct
  children?: React.ReactElement[]
}
export const ReportListWrapper = ({ product, children }: ProductListProps) => {
  if (!children) return null
  return (
    <AccordionContainer
      isDisabled
      marginTop="12px"
      key={product.id}
      title={product.title}
      isChild={false}>
      {children}
    </AccordionContainer>
  )
}

export const LoadingSkeleton = () => (
  <VStack
    mt={12}
    spacing={16}
    align="stretch"
    w="full"
    pt={4}>
    {/* Skeleton Element 1 */}
    <Box maxW="full">
      <Skeleton
        height="20px"
        w="full"
      />
      <Skeleton
        height="80px"
        w="full"
        mt={2}
      />
    </Box>

    {/* Skeleton Element 2 */}
    <Box maxW="full">
      <Skeleton
        height="20px"
        w="full"
      />
      <Skeleton
        height="80px"
        w="full"
        mt={2}
      />
    </Box>

    {/* Skeleton Element 3 */}
    <Box maxW="full">
      <Skeleton
        height="20px"
        w="full"
      />
      <Skeleton
        height="80px"
        w="full"
        mt={2}
      />
    </Box>
  </VStack>
)

export default ReportListContainer
